module.exports = __webpack_public_path__ + "img/article7.35f544e6.jpg";